import React from "react";
import {Field} from "formik";
import {Form, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import FontAwesome from "../../../utils/FA";
import './styles/PermissionGroups.scss';


export const PermissionChecklist = ({flags, values, setValues, handleChange, disabled}) => {
  const allSelected = (values) => flags.every(flag => !!values[flag.canonical_name]);
  const clickSelectAll = (values, setValues) => {
    const value = !allSelected(values);
    flags.forEach(flag => values[flag.canonical_name] = value);
    setValues(values);
  };

  return <Row>
          <label className="form-label col-form-label col-8 text-end">Permissions</label>
          <div className="controls col-16">
            <Field
              as={Form.Check}
              id='select-all'
              className='permission-group-select-all'
              label='Select All'
              name='select-all'
              type='checkbox'
              disabled={disabled}
              checked={allSelected(values)}
              onChange={() => clickSelectAll(values, setValues)}
            />
            {flags.map(flag => (<Field
              as={Form.Check}
              id={flag.canonical_name}
              label={(<>
              {flag.name}
              <OverlayTrigger
                placement='right'
                overlay={(
                  <Tooltip id={`tooltip-${flag.canonical_name}`}>
                    {flag.description}
                  </Tooltip>
                )}
              >
                <FontAwesome name='info-circle' preNbsp />
              </OverlayTrigger>
            </>)}
              name={flag.canonical_name}
              type='checkbox'
              disabled={disabled}
              defaultChecked={values[flag.canonical_name]}
              onChange={handleChange}
            />))}
          </div>
        </Row>
};
